<template>
  <ContentWrapper>
    <div class="content-heading">
      <div>개체등록</div>
    </div>
    <div v-show="data.params.mode=='detail'" class="card card-default">
      <div class="card-body">
        <form data-vv-scope="edit">
          <table class="table table-bordered">
            <colgroup>
              <col width="15%" class="bg-lightdark"/>
              <col width="35%"/>
              <col width="15%" class="bg-lightdark"/>
              <col width="35%"/>
            </colgroup>
            <tr>
              <th>개체유형 선택*</th>
              <td colspan="3">
                <div>
                  <input class="ml-2" id="textFile" type="checkbox" name="fileKind" v-model="data.row.fileTypeCd" true-value="211001" @click="AllClearCheck(); docFile=true; data.row.fileTypeCd = '211001'"/>
                  <label class="form-check-labe ml-1" for="textFile">문서파일</label>
                  <input class="ml-2" id="mediaFile" type="checkbox" name="fileKind" v-model="data.row.fileTypeCd" true-value="211002" @click="AllClearCheck(); mediaFile=true; data.row.fileTypeCd = '211002'"/>
                  <label class="form-check-labe ml-1" for="mediaFile">멀티미디어(mp3,mp4)</label>
                  <input class="ml-2" id="fileUrl" type="checkbox" name="fileKind" v-model="data.row.fileTypeCd"  true-value="211003" @click="AllClearCheck(); exterUrl=true; data.row.fileTypeCd = '211003'"/>
                  <label class="form-check-labe ml-1" for="fileUrl">외부링크</label>
                  <input class="ml-2" id="contentsUrl" type="checkbox" name="fileKind" v-model="data.row.fileTypeCd" true-value="211004" @click="AllClearCheck(); contentsUrl=true; data.row.fileTypeCd = '211004' "/>
                  <label class="form-check-labe ml-1" for="contentsUrl">콘텐츠링크</label>
                  <input class="ml-2" id="zipFile" type="checkbox" name="fileKind" v-model="data.row.fileTypeCd" true-value="211005" @click="AllClearCheck(); webContents=true; data.row.fileTypeCd = '211005'"/>
                  <label class="form-check-labe ml-1" for="zipFile">웹콘텐츠 등록(zip)</label>
                </div>
              </td>
            </tr>
            <tr>
              <th>
                <span v-show="!exterUrl && !contentsUrl"> 원본파일*</span>
                <span v-show="exterUrl || contentsUrl"> 링크경로*</span>
              </th>
              <td colspan="3"> 
                <div class="custom-file" style="height:2.1875rem" v-show="!exterUrl && !contentsUrl">
                  <input type="file" ref="file" class="display-file" id="newfile" @change="insertFileName">
                  <label class="custom-file-label" for="newfile">Choose a file...</label>
                  <div class="mt-2" style="margin-top : 20px !important">{{fileName}}</div>
                </div>
                <div v-show="exterUrl || contentsUrl">
                  <input type="text" v-model="data.row.linkUrl" :class="{'form-control':true, 'is-invalid': errors.has('edit.extFileId')}"
                       v-validate="''" name="newfile" style="width: 100%" placeholder="Url..."/>
                </div>
                <div v-show="webContents">※ 웹콘텐츠(ZIP) 압축파일 등록 시 압축 해제 및 서비스 가능 상태 변경에 시간이 소요됩니다.</div>
              </td>
            </tr>
            <tr v-show="!exterUrl && !contentsUrl">
              <th>
                <span v-show="!exterUrl && !contentsUrl">미리보기파일</span>
              </th>
              <td colspan="3">
                <div class="custom-file" style="height:2.1875rem" v-show="!exterUrl && !contentsUrl">
                  <div class="form-check mb-2">
                    <input class="form-check-input" v-model="data.row.contentsViewFileUploadYn" true-value="Y" false-value="N" type="checkbox" @click="checkPreviewUpload();"/>
                    <label class="form-check-label">VIEW용 PDF 업로드(첨부파일이 PDF로 변환이 불가한 경우)</label>
                  </div>
                  <input type="file" accept=".pdf" :disabled="previewUploadYN == false" ref="file" class="display-file" id="previewNewFile" @change="insertPreviewFileName">
                  <label class="custom-file-label" for="previewNewFile" :style=" {backgroundColor: previewUploadYN == false ? 'lightgray' : '' } ">Choose a file...</label>
                  <div class="mt-2" style="margin-top : 20px !important">{{previewFileName}}</div>
                </div>
              </td>
            </tr>
            <tr>
              <th>
                <span>썸네일링크</span>
              </th>
              <td colspan="3">
                  <input type="text" v-model="data.row.thumbnailPath"  :class="{'form-control':true}"
                      name="thumbnailPath" style="width: 100%" placeholder="Url..."/>
              </td>
            </tr>
            <tr>
              <th >노출개체명*</th>
               <td colspan="3">
                  <input type="text" :class="{'form-control':true, 'is-invalid': errors.has('edit.dispFileNm')}"
                        v-model="data.row.dispFileNm" placeholder="dispFileNm" v-validate="''" name="dispFileNm"
                        style="width: 100%"/>
                  <span v-show="errors.has('edit.dispFileNm')" class="invalid-feedback">{{
                      errors.first('edit.dispFileNm')
                    }}</span>
               </td>
            </tr>
            <tr>
               <th>노출대상 설정</th>
              <td colspan="3">
                <b-input-group>
                  <div>
                    <div class="form-check ml-2" style="display:flex;padding-left:unset;">
                      <div>
                        <input class="form-check-input ml-2" v-model="data.row.teacherUseYn" true-value="Y" false-value="N" type="checkbox"/>
                        <label class="form-check-label ml-4">교사사용</label>
                      </div>
                      <div>
                        <input class="form-check-input ml-2" v-model="data.row.tutorUseYn" true-value="Y" false-value="N" type="checkbox"/>
                        <label class="form-check-label ml-4">강사사용</label>
                      </div>
                      <div>
                        <input class="form-check-input ml-2" v-model="data.row.studentUseYn" true-value="Y" false-value="N" type="checkbox"/>
                        <label class="form-check-label ml-4">학생사용</label>
                      </div>
                    </div>
                  </div>
                </b-input-group>
              </td>
            </tr>
            <tr>
              <th>키워드</th>
              <td colspan='3'>
                <Keyword :box="keywords.box" :boxText="keywords.text" :type="'key'" @keywordChange="keywordChange" @keywordRemove="keywordRemove" :key="keywords.text"/>
              </td>
            </tr>
            <tr>
              <th>태그</th>
              <td colspan='3'>
                <Keyword :box="tags.box" :boxText="tags.text" :type="'tag'" @keywordChange="keywordChange" @keywordRemove="keywordRemove" :key="tags.text"/>
              </td>
            </tr>
          </table>
        </form>
      </div>
    </div>
    <div>
      <div div class="content-heading mt-1">
        <div v-show="contSeq">매핑정보</div>
      </div>
      <div v-show="contSeq" class="card card-default">
        <div class="card-body">
          <form data-vv-scope="edit">
            <table class="table table-bordered">
              <colgroup>
                <col width="15%" class="bg-lightdark"/>
                <col width="35%"/>
                <col width="15%" class="bg-lightdark"/>
                <col width="35%"/>
              </colgroup>
              <tr>
                <th>콘텐츠 용도 *</th>
                <td>
                  <b-input-group>
                    <div>
                      <b-form-select v-model="data.row.purpTypeCd" :options="exterUrl? purpTypeCd_exterUrl : purpTypeCd" @change="exterUrl_addition1 = data.row.purpTypeCd == '209007'; exterUrl_addition2 = false; exterUrl_addition3 = false; data.row.purpTypeCd_sub1 = undefined; data.row.purpTypeCd_sub2 = undefined; data.row.purpTypeCd_sub3 = undefined; purpTypeCd_sub1_options = purpTypeCd_exterUrl_sub.filter(cd => data.row.purpTypeCd && cd.p_code.endsWith(data.row.purpTypeCd))"></b-form-select>
                      <div v-show="exterUrl && exterUrl_addition1" class="mt-1">
                        <b-form-select v-model="data.row.purpTypeCd_sub1" :options="purpTypeCd_sub1_options" @change="exterUrl_addition2 = true; exterUrl_addition3 = false; purpTypeCd_sub2 = undefined; data.row.purpTypeCd_sub3 = undefined; purpTypeCd_sub2_options = purpTypeCd_exterUrl_sub.filter(cd => data.row.purpTypeCd_sub1 && cd.p_code.endsWith(data.row.purpTypeCd_sub1))"></b-form-select>
                      </div>
                      <div v-show="exterUrl && exterUrl_addition1 && exterUrl_addition2" class="mt-1">
                        <b-form-select v-model="data.row.purpTypeCd_sub2" :options="purpTypeCd_sub2_options" @change="exterUrl_addition3 = true; data.row.purpTypeCd_sub3 = undefined; purpTypeCd_sub3_options = purpTypeCd_exterUrl_sub.filter(cd => data.row.purpTypeCd_sub2 && cd.p_code.endsWith(data.row.purpTypeCd_sub2))"></b-form-select>
                      </div>
                      <div v-show="exterUrl && exterUrl_addition1 && exterUrl_addition2 && exterUrl_addition3" class="mt-1">
                        <b-form-select v-model="data.row.purpTypeCd_sub3" :options="purpTypeCd_sub3_options"></b-form-select>
                      </div>
                    </div>
                  </b-input-group>
                </td>
                <th>유료여부</th>
                <div class="form-check mt-2 ml-2">
                  <input class="form-check-input" v-model="data.row.payYn" true-value="Y" false-value="N" type="checkbox"/>
                  <label class="form-check-label">유료</label>
                </div>
                <span class="mt-1 ml-2"> ※ 체크하면 유료로 전환됩니다.</span>
              </tr>
              <tr v-show="mediaFile">
                <th>동영상 재생<br>시작 시간 (초)</th>
                <td>
                  <input type="text" :class="{'form-control':true, 'is-invalid': errors.has('edit.playStartTime')}"
                        v-model="data.row.playStartTime" placeholder="playStartTime" v-validate="''" name="playStartTime"
                        style="width: 200px"/>
                  <span v-show="errors.has('edit.playStartTime')" class="invalid-feedback">
                      {{contSeq}}
                    </span>
                </td>
                <th>동영상 재생<br>종료 시간 (초){{data.row.test}}</th>
                <td>
                  <input type="text" :class="{'form-control':true, 'is-invalid': errors.has('edit.playEndTime')}"
                        v-model="data.row.playEndTime" placeholder="playEndTime" v-validate="''" name="playEndTime"
                        style="width: 200px"/>
                  <span v-show="errors.has('edit.playEndTime')" class="invalid-feedback">{{
                      errors.first('edit.playEndTime')
                    }}</span>
                </td>
              </tr>
            </table>
          </form>
        </div>
      </div>     
      <div class="footer">
        <div class="float-right">
            <b-button @click="close()" class="btn btn-b btn-outline-danger mr-2" variant="outline-info mr-2">취소</b-button>
            <b-button @click="s3FileUpload()" class="btn btn-b btn-info mr-2" variant="info mr-2">저장</b-button>
        </div>
      </div>
    </div>
    <!-- // 상세 -->

    <loading :active="modalLoading" :is-full-page="true"/>
  </ContentWrapper>
</template>
<script>
import {reactive, ref, computed, onMounted, onUnmounted, onBeforeMount} from '@vue/composition-api'
import {getCsFileList, getCsFileItem, saveCsFile, deleteCsFile, uploadCsFile, uploadCsFileNotMapping} from "@/api/cs/CsFileApi";
import {getCsFileMappingItem, saveCsFileMapping, deleteCsFileMapping} from "@/api/cs/CsFileMappingApi";
import Pagenation from "@/components/Common/Pagenation";
import {dataObject,bookTypeCd,subjectCd,aws_cdn_path,purpTypeCd,purpTypeCd_exterUrl,purpTypeCd_exterUrl_sub} from "@/utils/Constants";
import {TableActionClass} from "@/utils/TableActionClass";
import SchDateRange from "../../components/Common/SchDateRange";
import SchText from "../../components/Common/SchText";
import Keyword from "../../components/Common/Keyword";
import Datepicker from 'vuejs-datepicker';
import swal from 'sweetalert2';

// 로딩처리
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
  components: {SchDateRange, SchText, Pagenation,Keyword, Datepicker, Loading},
  props: {
    contSeq: Number,
    saveType:'',
    orgContSeq : Number,
    atrbInfo:[],
  },
  setup(props, context) {
    // const schOptions = [{value: '209001', text: '수업용1'}, {value: '209002', text: '수업용2'},{value: '209003', text: '과제용'},{value: '209004', text: '평가용'},{value: '209005', text: '연구용'}]
    const _dataObject = _.cloneDeep(dataObject); //cloneDeep 객체복사 
    const data = reactive(_dataObject) //reactive 반응형 
    props.contSeq = (props.contSeq||0) > 0 ? props.contSeq : props.orgContSeq;
    data.row.contSeq = props.contSeq;
    data.row.fileTypeCd = '211001';
    data.row.purpTypeCd = '209001';

    const keywords = reactive({
      box : [],
      text : '',
    });
    const tags = reactive({
      box : [],
      text : '',
    });

    const modalLoading = ref(false);
    const docFile = ref(true); //문서파일
    const mediaFile = ref(false); //멀티미디어
    const exterUrl = ref(false); //외부링크
    const exterUrl_addition1 = ref(false); //외부링크 -> 부가자료
    const exterUrl_addition2 = ref(false); //외부링크 -> 부가자료
    const exterUrl_addition3 = ref(false); //외부링크 -> 부가자료
    const purpTypeCd_sub1_options = ref([]); //외부링크 -> 부가자료
    const purpTypeCd_sub2_options = ref([]); //외부링크 -> 부가자료
    const purpTypeCd_sub3_options = ref([]); //외부링크 -> 부가자료
    const contentsUrl = ref(false); //콘텐츠 링크
    const webContents = ref(false); //웹 콘텐츠 등록

    const fileName = ref('');
    const filedata = ref();
    const previewFileName = ref('');
    const previewFileData = ref('');
    const previewUploadYN = ref(false);

    const loadData = async () => {
      // modal open
        
        data.params.mode = 'detail';
        
        console.log("개체등록,", props);
        console.log("modal OPEN : " + props.fileSeq);
    }
    onMounted(loadData)

    const close = () =>{
      context.emit('modal-state', 'addfile' );
    }

    const refreshFiles = () => {
      context.emit('get-data', {
          contSeq : props.orgContSeq,
          atrbInfo : props.atrbInfo,
          version : 'addfile'
      });
      return false;
    }

    const s3FileUpload = async() => {
      if (data.row.fileTypeCd == '211001' || //문서파일
          data.row.fileTypeCd == '211002' || //멀티미디어
          data.row.fileTypeCd == '211005') //웹콘텐츠 등록
      {
        // 외부링크,콘텐츠링크는 첨부파일이 없음
        if (!!filedata.value == false) {
          alert('선택된 파일이 없습니다.');
          return;
        }
      }
      if (!!data.row.dispFileNm == false) {
        alert('노출개체명을 입력해주세요.');
        return;
      }
      var formData = new FormData();
      formData.append("fileTypeCd", data.row.fileTypeCd);
      formData.append("mfile",filedata.value);
      formData.append("dispFileNm",data.row.dispFileNm);
      formData.append("teacherUseYn",(data.row.teacherUseYn === undefined)? 'N':data.row.teacherUseYn);
      formData.append("tutorUseYn",(data.row.tutorUseYn === undefined) ? 'N':data.row.tutorUseYn);
      formData.append("studentUseYn",(data.row.studentUseYn === undefined)? 'N':data.row.studentUseYn);
      formData.append("keywords",(keywords.text === undefined) ? '' : keywords.text);
      formData.append("tags",(tags.text === undefined) ? '' : tags.text);
      formData.append("linkUrl",(data.row.linkUrl === undefined) ? '' : data.row.linkUrl);
      formData.append("contentsViewFileUploadYn",(data.row.contentsViewFileUploadYn === undefined) ? 'N' : data.row.contentsViewFileUploadYn);
      formData.append("mfilePreview",previewFileData.value);
      formData.append("thumbnailPath",(data.row.thumbnailPath === undefined) ? '' : data.row.thumbnailPath);

      if (props.contSeq) {
        let purpTypeCd = (data.row.purpTypeCd === undefined)? '' : data.row.purpTypeCd;
        if (data.row.fileTypeCd == '211003' && purpTypeCd == '209007') { // 외부링크 -> 부가자료이면 최 하단 카테고리코드 적용.
          purpTypeCd = data.row.purpTypeCd_sub3 || data.row.purpTypeCd_sub2 || data.row.purpTypeCd_sub1 || data.row.purpTypeCd;
        }
        formData.append("purpTypeCd",purpTypeCd);
        formData.append("contSeq",data.row.contSeq);
        formData.append("payYn",(data.row.payYn === undefined) ? 'N':data.row.payYn);
        formData.append("playStartTime",(data.row.playStartTime === undefined) ? '' : data.row.playStartTime);
        formData.append("playEndTime",(data.row.playEndTime === undefined) ? '' : data.row.playEndTime);
        formData.append("menuType",(props.saveType == 'ins') ? "moment" : "textBook");
      }
      
      modalLoading.value = true;
      const result = props.contSeq ? await uploadCsFile(formData) : await uploadCsFileNotMapping(formData);
      modalLoading.value = false;
      swal({
        title: "SmartSchool 개체등록",
        text: "개체업로드 완료",
        confirmButtonColor: "#DD6B55",
        confirmButtonText: "OK",
        heightAuto: false
      })
      .then((result) => {
        if(result.value){
          refreshFiles();
        } 
      });
    }

    const AllClearCheck = () =>{
      docFile.value = false;
      mediaFile.value = false;
      exterUrl.value = false;
      contentsUrl.value = false;
      webContents.value = false;
    }
    const checkPreviewUpload = () =>{
      previewUploadYN.value = (previewUploadYN.value == true)?false:true;
    }

    const insertFileName = (e) =>{
      var input = e.target;
      fileName.value = input.files[0].name;
      if (input.files && input.files[0]) { 
        var reader = new FileReader();
        reader.onload = (e) => {
          //uploadImageFile.value = e.target.result;  //이미지 미리보기
        }
        filedata.value = input.files[0];
        reader.readAsDataURL(input.files[0]);
      }
    }
    const insertPreviewFileName = (e) =>{
      var input = e.target;
      previewFileName.value = input.files[0].name;
      if (input.files && input.files[0]) { 
        var reader = new FileReader();
        reader.onload = (e) => {          
          //uploadImageFile.value = e.target.result;  //이미지 미리보기
        }
        previewFileData.value = input.files[0]
        reader.readAsDataURL(input.files[0]);
      }
    }

    const settingKeywords = (text) => {
      keywords.text = _.cloneDeep(text);
      keywords.box = _.cloneDeep(text.split(","));
      if(keywords.text.charAt(keywords.text.length-1) == ',' ){  // 마지막 
          keywords.box.map ((row , i)=>{
              if(row == ''){
                keywords.box.splice(i,1);
              }
          });
      }
      text = '';
    }
    const settingTags = (text) => {
      tags.text = _.cloneDeep(text);
      tags.box = _.cloneDeep(text.split(","));
      if(tags.text.charAt(tags.text.length-1) == ',' ){  // 마지막 
          tags.box.map ((row , i)=>{
              if(row == ''){
                tags.box.splice(i,1);
              }
          });
      }
      text = '';
    }

    const keywordChange = (box,text,type) =>{
      if(type == "key"){
        keywords.box = box;
        keywords.text = text;
        data.row.keywords = '';
      }else{
        tags.box = box;
        tags.text = text;
        data.row.tags = '';
      }
    }

    const keywordRemove = ( box , text , type) =>{
      if(type == "key"){
         keywords.box = box;
         keywords.text = text;
      }
      else{
        tags.box = box;
        tags.text = text;
      }
    }

    return {
      modalLoading,
      purpTypeCd,
      purpTypeCd_exterUrl,
      purpTypeCd_exterUrl_sub,
      data,
      subjectCd,
      close,
      fileName,
      filedata,
      previewFileName,
      insertFileName,
      insertPreviewFileName,
      s3FileUpload,
      docFile,
      mediaFile,
      exterUrl,
      exterUrl_addition1,
      exterUrl_addition2,
      exterUrl_addition3,
      purpTypeCd_sub1_options,
      purpTypeCd_sub2_options,
      purpTypeCd_sub3_options,
      contentsUrl,
      webContents,
      keywords,
      tags,
      keywordRemove,
      AllClearCheck,
      checkPreviewUpload,
      previewUploadYN,
      keywordChange,
      settingKeywords,
      settingTags,
      refreshFiles,
      ...methods(),
      dataAction: new TableActionClass(data),
    }
  },
}

function methods() {
  var context = {};
  context["getCsFileList"] = getCsFileList;  // get list
  context["getCsFileItem"] = getCsFileItem;  // get item
  context["deleteCsFile"] = deleteCsFile;  // delete item
  context["saveCsFile"] = saveCsFile;  // save item
  context["uploadCsFile"] = uploadCsFile; // upload csFile
  context["getCsFileMappingItem"] = getCsFileMappingItem; // get item 
  context["saveCsFileMapping"] = saveCsFileMapping; // save item 
  context["deleteCsFileMapping"] = deleteCsFileMapping; // delete item
  
  // 목록
  async function search() {
    let _params = this.data.params
    this.dataAction.execute("getCsFileList", context, _params);
  }

  // 상세
  async function edit(_item) {
    let _params = {
      fileSeq : _item.fileSeq
    }
    await this.dataAction.execute("getCsFileItem", context, _params);
  }

  // 삭제
  async function remove(_params) {
    _params = !_params ? this.data.row : _params
    await this.dataAction.execute("deleteCsFile", context, _params);
    
    this.search();
  }

  // 저장
  async function save() {
    const validForm = await this.$validator.validateAll('edit').then((result) => {
      return result;
    });
    if (validForm) {
      let _params = this.data.row
      await this.dataAction.execute("saveCsFile", context, _params).then((result) => {
        let _paramsMpp = {
        contSeq: _params.contSeq,
        fileSeq: result.data,
        orderNum: _params.orderNum,
        playStartTime: _params.playStartTime,
        playEndTime: _params.playEndTime,
        fileTypeCd : _params.fileTypeCd,
      }
      this.dataAction.execute("saveCsFileMapping", context, _paramsMpp);
        close();
        refreshFiles();
      return result;
      });
    }
  }

  // 초기화
  async function reset() {
    this.dataAction.clear();
  }

  return {reset, search, edit, save, remove}
}

</script>